// Papéis com permissões administrativas (o backend valida por ADMIN_ROLES;
// esta lista deve estar em sincronia com backend/auth_utils.py).
export const ADMIN_ROLES = ["admin", "diretor_financeiro", "presidente"];

export const isAdminRole = (role) => ADMIN_ROLES.includes(role);
